<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-container
        :class="{
          'px-10': !mobile,
          'pt-8': !mobile,
          'px-6': mobile,
          'pt-4': mobile
        }"
      >
        <p class="subtitle-1 font-weight-bold mb-2">Pre-terminate Lease</p>
        <v-row>
          <v-col class="pb-0" cols="12" sm="12">
            <v-textarea
              v-model="message"
              name="message"
              label="Enter reason of pre-termination"
              outlined
              dense
            >
              <template v-slot:prepend-inner>
                <v-icon small class="mt-1">mdi-information</v-icon>
              </template>
            </v-textarea>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="font-weight-bold"
            color="primary darken-1"
            text
            @click="finish"
            >Finish</v-btn
          >
          <v-btn
            class="font-weight-bold"
            color="grey darken-1"
            text
            @click="cancel"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-container>
    </v-card>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      tenantId: -1,
      bedId: -1,
      dialog: false,
      options: {
        color: 'warning',
        width: 500,
        zIndex: 200
      },
      message: '',
      loading: false
    }
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.xs
    }
  },
  methods: {
    open(tenant) {
      this.leaseId =
        tenant.leaseId ||
        (tenant.lease_details && tenant.lease_details.tenantId)
      this.bedId = tenant.bedId
      this.dialog = true
      //this.options = Object.assign(this.options, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    async finish() {
      try {
        this.dialog = false
        const confirm = await this.$root.$confirm({
          title: 'Pre-terminate lease',
          message: `Are you sure you want to pre-terminate this lease?`,
          confirmText: 'Yes'
        })

        if (confirm) {
          // evict here
          this.loading = true
          this.$store
            .dispatch('units/preterminateAction', {
              leaseId: this.leaseId,
              reason: this.message
            })
            .then(() => {
              this.$root.$confirm({
                title: 'Pre-terminate lease',
                message: `The lease has been successfully pre-terminated.`,
                confirmOnly: true,
                confirmText: 'OK'
              })
              this.loading = false
              this.resolve(true)
              this.message = ''
            })
            .catch((err) => {
              this.loading = false
              this.reject(err)
            })
        } else {
          this.message = ''
          await this.$root.$confirm({
            title: 'Pre-terminate lease',
            message: `The process was canceled.`,
            confirmOnly: true,
            confirmText: 'OK'
          })
          this.loading = false
          this.reject(false)
        }
      } catch (err) {
        if (err.status === 500) {
          this.loading = false
          this.$root.$confirm({
            title: 'Pre-terminate lease',
            message: `There was an error processing your request.`,
            options: {
              color: 'error'
            },
            reconfirmOnly: true,
            confirmText: 'OK'
          })
          this.reject(false)
        }
      }
    },
    cancel() {
      this.dialog = false
      this.loading = false
    }
  }
}
</script>

<style scoped>
p {
  margin-bottom: 0 !important;
}
</style>
